import { get } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchModuleScreen = (
  id: string,
  mid: string,
  sid: string
): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/modules/${mid}/module-screens/${sid}`, {
    include: [
      'blocks',
      'blocks.gallery',
      'blocks.files',
      'blocks.links',
      'blocks.videos',
      'blocks.notion',
    ].join(','),
  })

export const fetchModule = (id: string, mid: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/modules/${mid}`, {
    include: 'lessonsCount,userModule',
  })

export const fetchModulesList = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/modules`, {
    include: 'userModule,moduleScreens',
  })

export const fetchCourseUserState = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/user-state`)

export const fetchAchievements = (period: string): Promise<AxiosResponse> =>
  get('/achievements/achievements', {
    'filter[achieved_at]': period,
    include: 'imageMedia,userAchievement',
    sort: '-user_achievement',
  })
